<!-- #BR#105 - Mbeng - copy trading page - 28/07/2025 -->
<template>
    <div class="copy-trading ">
      <!-- Header Section -->
      <Header class="responsive-bar">
        <template v-slot:title>
          {{ $t("copy-trading") }}
        </template>
      </Header>
  
      <div class="bg-gray-50 shadow rounded-md min-h-screen max-w-3xl m-auto sm:mt-5 py-10 px-6">
        <h3 class="text-lg font-medium text-gray-900 mb-6">
          {{ $t('copy-trading') }}
        </h3>
  
        <tabs class="tab mt-4" v-model="activeTab" @update:modelValue="onTabChange"  :options="{ useUrlFragment: false }">
        
        <!-- Follower Tab -->
        <tab :name="$t('follower-registration-form')" :selected="true" :title="$t('follower')" id="follower-registration-form" value="follower">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(submitFormFollower)">
               
                
              <div class="mt-4 space-y-3">
                <div class="col-span-2">
                    <h3 class="col-span-2 text-lg font-semibold mt-6 mb-3 border-b pb-2">{{ $t('personal-account-information') }}</h3>
                </div>
                <ValidationProvider name="full name" rules="required" v-slot="{ errors }">
                  <label class="block" :for="'name'" :placeholder="$t('full-name')">
                    {{$t('full-name')}}
                    <input id="name" v-model="followerForm.name" type="text" 
                    class="input mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-200 focus:border-blue-500 bg-gray-100 text-gray-700 cursor-not-allowed" 
                    readonly />
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider><br>
                 
                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                  <label class="block" :for="'follower-email'" >
                    {{$t('icm-registered-email')}}
                    <input id="email" v-model="followerForm.email" type="email" 
                    class="input mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-200 focus:border-blue-500 bg-gray-100 text-gray-700 cursor-not-allowed" 
                    readonly
                    />
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider><br>
                
                <ValidationProvider name="MT4 Account" rules="required" v-slot="{ errors }">
                  <label class="block" :for="'account'">
                    {{ $t('trading-account-number') }}
                    <!-- <select id="account" v-model="followerForm.account" class="input">
                      <option disabled value="">{{ $t('select-an-option') }}</option>
                      <option
                        v-for="acc in filteredLiveBackends"
                        :key="acc.id"
                        :value="acc.id"
                      >
                        {{ acc.name }}
                      </option>
                    </select> -->
                    <span class="text-red-500">*</span>
                    <input id="account" v-model="followerForm.account" type="number" class="input" :placeholder="$t('trading-account-number')"/>
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider>

                <!-- <h3 class="col-span-2 text-lg font-semibold mt-6 mb-2 border-b pb-1">{{ $t('copy-trading-preferences') }}</h3> -->
                <div class="col-span-2">
                    <h3 class="text-lg font-semibold mt-6 mb-3 border-b pb-2">
                    {{ $t('copy-trading-preferences') }}
                    </h3>
                </div>

                <ValidationProvider name="Preferred Provider" rules="" v-slot="{ errors }">
                  <label class="block" :for="'preferred_provider'">
                    {{$t('preferred-provider')}}
                    <input id="preferred_provider" v-model="followerForm.preferred_provider" type="text" class="input" />
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider><br>

                <ValidationProvider name="Capital Allocation" rules="required" v-slot="{ errors }">
                  <label class="block" :for="'capital'">
                    {{$t('capital-allocation')}} <span class="text-red-500">*</span>
                    <select id="capital" v-model="followerForm.capital" class="input">
                      <option disabled value="">{{ $t('select-an-option') }}</option>
                      <option>50 USD – 100 USD</option>
                      <option>100 USD – 500 USD</option>
                      <option>500 USD – 1,000 USD</option>
                      <option>1,000 USD – 5,000 USD</option>
                      <option>>5,000 USD</option>
                    </select>
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                    
                  </label>
                </ValidationProvider>

                <!-- <ValidationProvider name="Amount" rules="required|min_value:1" v-slot="{ errors }">
                  <label class="block" :for="'amount'">
                    {{$t('amount') }} <span class="text-red-500">*</span>
                    <input id="amount" v-model="followerForm.amount" type="number" class="input" />
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                    
                  </label>
                </ValidationProvider> -->
              </div>

              <div class="mt-4 space-y-3">
                <!-- <h3 class="col-span-2 text-lg font-semibold mt-6 mb-2 border-b pb-1">{{ $t('acknowledgements-consent') }}</h3> -->
                <div class="col-span-2">
                    <h3 class="text-lg font-semibold mt-6 mb-3 border-b pb-2">
                    {{ $t('acknowledgements-consent') }}
                    </h3>
                </div>
                <ValidationProvider name="Risk Agreement" rules="required" v-slot="{ errors }">
                  <label class="inline-flex items-center" :for="'agree1'">
                    <input
                      id="agree1"
                      type="checkbox"
                      v-model="followerForm.agree1"
                      class="checkbox mt-1 mr-2"
                      name="agree1"
                      required
                    />
                    <span class="ml-2">
                      {{$t('follower-i-understand-that-copy-trading-involves-risk')}}
                    </span>
                    <span class="text-red-500">*</span>
                  </label>
                  <div class="text-red-500 text-sm">{{ errors[0] }}</div>
                </ValidationProvider>

                <ValidationProvider name="Strategy Acceptance" rules="required" v-slot="{ errors }">
                  <label class="inline-flex items-center" :for="'agree2'">
                    <input
                      id="agree2"
                      type="checkbox"
                      v-model="followerForm.agree2"
                      class="checkbox mt-1 mr-2"
                      name="agree2"
                      required
                    />
                    <span class="ml-2">
                      {{$t('follower-i-agree-to-monitor-my-account-and-take-full')}}
                    </span>
                    <span class="text-red-500">*</span>
                  </label>
                  <div class="text-red-500 text-sm">{{ errors[0] }}</div>
                </ValidationProvider>

                <!-- <ValidationProvider name="Terms Acceptance" rules="required" v-slot="{ errors }">
                  <label class="inline-flex items-center" :for="'agree3'" v-if="whitelabel === 'ICMMU'">
                    <input
                      id="agree3"
                      type="checkbox"
                      v-model="followerForm.agree3"
                      class="checkbox mt-1 mr-2"
                      name="agree3"
                      required
                    />
                    <span class="ml-2" v-html="$t('follower-i-accept-the-copy-trading-terms-and-conditions-mu')">
        
                    </span>
                    <span class="text-red-500">*</span>
                  </label>
                  <label class="inline-flex items-center" :for="'agree3'" v-else>
                    <input
                      id="agree3"
                      type="checkbox"
                      v-model="followerForm.agree3"
                      class="checkbox mt-1 mr-2"
                      name="agree3"
                      required
                    />
                    <span class="ml-2" v-html="$t('follower-i-accept-the-copy-trading-terms-and-conditions-vc')">
                     
                    </span>
                    <span class="text-red-500">*</span>
                  </label>
                  <div class="text-red-500 text-sm">{{ errors[0] }}</div>
                </ValidationProvider> -->
                <ValidationProvider name="Terms Acceptance" rules="required" v-slot="{ errors }">
                <label class="inline-flex items-center" for="agree3">
                    <input
                    id="agree3"
                    type="checkbox"
                    v-model="followerForm.agree3"
                    class="checkbox mt-1 mr-2"
                    name="agree3"
                    />
                    <span class="ml-2 text-blue-600" v-html="getFollowerTermsLabel"></span>
                    <span class="text-red-500">*</span>
                </label>
                <div class="text-red-500 text-sm">{{ errors[0] }}</div>
                </ValidationProvider>

              </div>

              <div class="mt-10 flex justify-end">
                <button type="submit" class="btn" >{{$t("Submit")}}</button>
              </div>
            </form>
          </ValidationObserver>
        </tab>

        <!-- Provider Tab -->
        <tab :name="$t('provider-registration-form')" :title="$t('provider')" id="provider-registration-form" value="provider">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(submitFormProvider)">
              <div class="mt-4 space-y-3">

                <!-- <h3 class="col-span-2 text-lg font-semibold mt-6 mb-2 border-b pb-1">{{ $t('personal-account-information') }}</h3> -->
                <div class="col-span-2">
                    <h3 class="text-lg font-semibold mt-6 mb-3 border-b pb-2">
                    {{ $t('personal-account-information') }}
                    </h3>
                </div>
                <ValidationProvider name="full name" rules="required" v-slot="{ errors }">
                  <label class="block" :for="'name'">
                    {{$t('full-name')}}
                    <input id="name" v-model="providerForm.name" type="text" 
                    class="input mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-200 focus:border-blue-500 bg-gray-100 text-gray-700 cursor-not-allowed" 
                    readonly />
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider><br>

                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                  <label class="block" :for="'email'">
                    {{$t('icm-registered-email')}}
                    <input id="email" v-model="providerForm.email" type="email" 
                    class="input mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-200 focus:border-blue-500 bg-gray-100 text-gray-700 cursor-not-allowed" 
                    readonly />
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider><br>

                <ValidationProvider name="MT4 Account" rules="required" v-slot="{ errors }">
                  <label class="block" :for="'account'">
                    {{$t('trading-account-number')}} <span class="text-red-500">*</span>
                    <!-- <select id="account" v-model="providerForm.account" class="input">
                      <option disabled value="">{{ $t('select-an-option') }}</option>
                      <option
                        v-for="acc in filteredLiveBackends"
                        :key="acc.id"
                        :value="acc.id"
                      >
                        {{ acc.name }}
                      </option>
                    </select> -->
                    <input id="account" v-model="providerForm.account" type="number" class="input"  :placeholder="$t('trading-account-number')"/>
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider>
                

                <!-- <h3 class="col-span-2 text-lg font-semibold mt-6 mb-2 border-b pb-1">{{ $t('trading-profile') }}</h3> -->
                <div class="col-span-2">
                    <h3 class="text-lg font-semibold mt-6 mb-3 border-b pb-2">
                    {{ $t('trading-profile') }}
                    </h3>
                </div>
                <ValidationProvider name="Strategy Description" rules="required" v-slot="{ errors }">
                  <label class="block" :for="'strategy'">
                    {{$t('trading-strategy-description')}}
                    <span class="text-red-500">*</span>
                    <textarea id="strategy" v-model="providerForm.strategy" rows="4" class="input" maxlength="250"></textarea>
                    <div class="text-gray-500 text-xs mt-1">{{ providerForm.strategy?.length || 0 }}/250</div>
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider><br>

                <ValidationProvider name="Products Traded" rules="required" v-slot="{ errors }">
                  <label class="block" :for="'products_traded'">
                    {{$t('products-traded')}} <span class="text-red-500">*</span>
                    <div>
                      <label :for="'forex'">
                        <input id="forex" type="checkbox" value="Forex" v-model="providerForm.products_traded" />
                        {{$t('forex-cp')}}
                      </label><br />
                      <label :for="'commodities'">
                        <input id="commodities" type="checkbox" value="Commodities" v-model="providerForm.products_traded" />
                        {{$t('commodities')}}
                      </label><br />
                      <label :for="'indices'">
                        <input id="indices" type="checkbox" value="Indices" v-model="providerForm.products_traded" />
                        {{$t('indices')}}
                      </label><br />
                      <label :for="'crypto'">
                        <input id="crypto" type="checkbox" value="Crypto" v-model="providerForm.products_traded" />
                        {{$t('crypto')}}
                      </label><br />
                      <label :for="'others'">
                        <input id="others" type="checkbox" value="Others" v-model="providerForm.products_traded" />
                        {{$t('others')}}
                      </label>
                    </div>
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider><br>
                

                <ValidationProvider name="Holding Period" rules="required" v-slot="{ errors }">
                  <label class="block" :for="'holding_period'">
                    {{$t('average -holding -period')}} <span class="text-red-500">*</span>
                    <div>
                      <label :for="'scalping'">
                        <input id="scalping" type="checkbox" value="Scalping " v-model="providerForm.holding_period" />
                        {{$t('scalping')}}
                      </label><br />
                    
                      <label :for="'intraday'">
                        <input id="intraday" type="checkbox" value="Intraday " v-model="providerForm.holding_period" />
                        {{$t('intraday')}}
                      </label><br />
                  
                      <label :for="'swing'">
                        <input id="swing" type="checkbox" value="Swing " v-model="providerForm.holding_period" />
                        {{$t('swing')}}
                      </label><br />
                      
                      <label :for="'position'">
                        <input id="position" type="checkbox" value="Position " v-model="providerForm.holding_period" />
                        {{$t('position')}}
                      </label>
                    </div>
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider><br>

                <ValidationProvider name="Trades per Week" rules="required" v-slot="{ errors }">
                  <label class="block" :for="'trades'">
                    {{$t('number-of-trades-per-week')}} <span class="text-red-500">*</span>
                    <input id="trades" v-model="providerForm.trades" type="number" class="input" @input="providerForm.trades = providerForm.trades?.toString().slice(0,6)"/>
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider><br>

                <ValidationProvider name="Risk Management" rules="required" v-slot="{ errors }">
                  <label class="block" :for="'risk'">
                    {{$t('risk-management-approach')}} <span class="text-red-500">*</span>
                    <textarea id="risk" v-model="providerForm.risk" rows="3" class="input"  maxlength="250"></textarea>
                    <div class="text-gray-500 text-xs mt-1">{{ providerForm.risk?.length || 0 }}/250</div>
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider>
               
                <!-- <h3 class="col-span-2 text-lg font-semibold mt-6 mb-2 border-b pb-1">{{$t('performance-and-history')}}</h3> -->
                <div class="col-span-2">
                    <h3 class="text-lg font-semibold mt-6 mb-3 border-b pb-2">
                    {{ $t('performance-and-history') }}
                    </h3>
                </div>
                <!-- Upload Verified Trading History -->
                    <ValidationProvider name="tradingHistory">
                        <label class="block text-sm font-medium text-gray-700 mb-1">
                        {{$t('upload-verified-trading-history')}}
                    </label>

                    <div
                        class="flex flex-col items-center justify-center w-full border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50 hover:bg-gray-100 transition"
                    >
                        <input
                        type="file"
                        id="tradingHistory"
                        @change="handleFileUpload"
                        accept=".pdf,.doc,.docx,.xlsx,.xls,.csv,.jpg,.jpeg,.png"
                        class="mb-2 block w-full text-sm text-gray-900 cursor-pointer focus:outline-none"
                        />

                        <div v-if="providerForm.tradingHistoryFile" class="text-sm text-green-700">
                        <strong>Selected:</strong> {{ providerForm.tradingHistoryFile.name }}
                        ({{ (providerForm.tradingHistoryFile.size / 1024 / 1024).toFixed(2) }} MB)
                        </div>

                        <div v-if="providerForm.tradingHistoryError" class="text-sm text-red-600 mt-2">
                        {{ providerForm.tradingHistoryError }}
                        </div>
                    </div>
                    </ValidationProvider><br>

                <ValidationProvider name="Performance" v-slot="{ errors }">
                  <label class="block" :for="'performance'">
                    {{$t('performance-summary')}}  <!--<span class="text-red-500">*</span> -->
                    <input id="winRate" v-model="providerForm.winRate" :placeholder="$t('win-rate')" type="number" class="input" @input="providerForm.winRate = providerForm.winRate?.toString().slice(0,6)"/>
                    <input id="drawdown" v-model="providerForm.drawdown" :placeholder="$t('max-drawdown')" type="number" class="input " @input="providerForm.drawdown = providerForm.drawdown?.toString().slice(0,6)"/>
                    <input id="monthlyReturn" v-model="providerForm.monthlyReturn" :placeholder="$t('monthly-return')" type="number" class="input " @input="providerForm.monthlyReturn = providerForm.monthlyReturn?.toString().slice(0,6)"/>
                    <input id="totalReturn" v-model="providerForm.totalReturn" :placeholder="$t('total-return')" type="number" class="input " @input="providerForm.totalReturn = providerForm.totalReturn?.toString().slice(0,6)"/>
                    <!-- <span class="text-red-500 text-sm">{{ errors[0] }}</span> -->
                  </label>
                </ValidationProvider>
              
                <!-- <h3 class="col-span-2 text-lg font-semibold mt-6 mb-2 border-b pb-1">{{ $t('branding-and-visibility') }}</h3> -->
                <div class="col-span-2">
                    <h3 class="text-lg font-semibold mt-6 mb-3 border-b pb-2">
                    {{ $t('branding-and-visibility') }}
                    </h3>
                </div>

                <ValidationProvider name="Brand display"  v-slot="{ errors }">
                  <label class="block" :for="'brand'">
                    {{$t('brand')}}
                    <input id="brand" v-model="providerForm.brand" :placeholder="$t('brand')" type="text" class="input " />
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider><br>

                <!-- Upload logo -->
                <ValidationProvider name="logo">
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                      {{$t('strategy')}}
                    </label>

                <div
                    class="flex flex-col items-center justify-center w-full border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50 hover:bg-gray-100 transition"
                >
                    <input
                    type="file"
                    id="logo"
                    @change="handleFileUpload1"
                    accept=".pdf,.doc,.docx,.xlsx,.xls,.csv,.jpg,.jpeg,.png"
                    class="mb-2 block w-full text-sm text-gray-900 cursor-pointer focus:outline-none"
                    />

                    <div v-if="providerForm.logo" class="text-sm text-green-700">
                    <strong>Selected:</strong> {{ providerForm.logo.name }}
                    ({{ (providerForm.logo.size / 1024 / 1024).toFixed(2) }} MB)
                    </div>

                    <div v-if="providerForm.logoError" class="text-sm text-red-600 mt-2">
                    {{ providerForm.logoError }}
                    </div>
                </div>
                </ValidationProvider><br>

                <ValidationProvider name="Public Bio"  v-slot="{ errors }">
                  <label class="block" :for="'bio'">
                    {{$t('bio')}}
                    <textarea id="bio" v-model="providerForm.bio" rows="2" class="input" maxlength="250"></textarea>
                    <div class="text-gray-500 text-xs mt-1">{{ providerForm.bio?.length || 0 }}/250</div>
                    <span class="text-red-500 text-sm">{{ errors[0] }}</span>
                  </label>
                </ValidationProvider>
               
              </div>

              <div class="mt-4 space-y-3">
                <!-- <h3 class="col-span-2 text-lg font-semibold mt-6 mb-2 border-b pb-1">{{ $t('declarations-copy-trading') }}</h3> -->
                <div class="col-span-2">
                    <h3 class="text-lg font-semibold mt-6 mb-3 border-b pb-2">
                    {{ $t('declarations-copy-trading') }}
                    </h3>
                </div>
                <ValidationProvider name="Terms Agreement" rules="required" v-slot="{ errors }">
                  <label class="inline-flex items-center" :for="'agree1'">
                    <input
                      id="agree1"
                      type="checkbox"
                      v-model="providerForm.agree1"
                      class="checkbox mt-1 mr-2"
                      name="agree1"
                      required
                    />
                    <span class="ml-2"> {{$t('provider-i-confirm-that-the-information-provided')}}</span>
                    <span class="text-red-500">*</span>
                  </label>
                  <div class="text-red-500 text-sm">{{ errors[0] }}</div>
                </ValidationProvider>


                <!-- <ValidationProvider name="Provider Terms" rules="required" v-slot="{ errors }">
                  <label class="inline-flex items-center" :for="'agree2'" v-if="whitelabel==='ICMMU'">
                    <input
                      id="agree2"
                      type="checkbox"
                      v-model="providerForm.agree3"
                      class="checkbox mt-1 mr-2"
                      name="agree2"
                      required
        
                    />
                    <span class="ml-2" v-html="$t('provider-i-accept-the-copy-trading-provider-terms-and-conditions-mu')"></span>
                    <span class="text-red-500">*</span>
                  </label>
                  <label class="inline-flex items-center" :for="'agree2'" v-else-if="whitelabel==='ICMVC'">
                    <input
                      id="agree2"
                      type="checkbox"
                      v-model="providerForm.agree3"
                      class="checkbox mt-1 mr-2"
                      name="agree2"
                      required
                    />
                    <span class="ml-2" v-html="$t('provider-i-accept-the-copy-trading-provider-terms-and-conditions-vc')"></span>
                    <span class="text-red-500">*</span>
                  </label>
                  <label class="inline-flex items-center" :for="'agree2'" v-else>
                    <input
                      id="agree2"
                      type="checkbox"
                      v-model="providerForm.agree3"
                      class="checkbox mt-1 mr-2"
                      name="agree2"
                      required
                    />
                    <span class="ml-2" v-html="$t('provider-i-accept-the-copy-trading-provider-terms-and-conditions-trader')"></span>
                    <span class="text-red-500">*</span>
                  </label>
                  <div class="text-red-500 text-sm">{{ errors[0] }}</div>
                </ValidationProvider> -->
                <ValidationProvider name="Provider Terms" rules="required" v-slot="{ errors }">
                <label class="inline-flex items-center" for="agree2">
                    <input
                    id="agree2"
                    type="checkbox"
                    v-model="providerForm.agree3"
                    class="checkbox mt-1 mr-2"
                    name="agree2"
                    />
                    <span  class="ml-2 text-blue-600" v-html="getTermsLabel"></span>
                    <span class="text-red-500">*</span>
                </label>
                <div class="text-red-500 text-sm">{{ errors[0] }}</div>
                </ValidationProvider>

                <ValidationProvider name="Provider Risk" rules="required" v-slot="{ errors }">
                  <label class="inline-flex items-center" :for="'agree3'">
                    <input
                      id="agree3"
                      type="checkbox"
                      v-model="providerForm.agree2"
                      class="checkbox mt-1 mr-2"
                      name="agree3"
                      required
                    />
                    <span class="ml-2">{{$t('provider-i-understand-the-risks-and-responsibilities-of-being-a-strategy-provider')}}</span>
                    <span class="text-red-500">*</span>
                  </label>
                  <div class="text-red-500 text-sm">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>

              <div class="mt-10 flex justify-end">
                <button type="submit" class="btn" >{{$t("Submit")}}</button>
              </div>
            </form>
          </ValidationObserver>
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Header from "@/components/Header";
import { Tabs, Tab } from 'vue-tabs-component';
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Vue from "vue";
import VueI18Next from "@panter/vue-i18next";
import i18next from "i18next";
import { nextTick } from 'vue';


Vue.use(VueI18Next);
const i18n = new VueI18Next(i18next);

export default {
  name: "CopyTrading",
  components: {
    Header,
    Tabs,
    Tab,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      followerForm: {
        name: "",
        email: "",
        account: "",
        preferred_provider: "",
        capital: "",
        amount: "",
        agree1: false,
        agree2: false,
        agree3: false,
        id:"",
        username:"",
      },
      providerForm: {
        name: "",
        email: "",
        account: "",
        strategy: "",
        products_traded: [],
        holding_period: [],
        trades: "",
        risk: "",
        winRate: "",
        drawdown: "",
        monthlyReturn: "",
        totalReturn: "",
        bio: "",
        brand:"",
        logo:null,
        logoError:"",
        agree1: false,
        agree2: false,
        agree3: false,
        tradingHistoryFile: null, 
        tradingHistoryError: "",
        id:"",
        username:"",
      },
      isDisabled: false,
      fullName:'',
      activeTab: "follower", // default
      whitelabel: process.env.VUE_APP_WHITELABEL,
    };
  },
  computed: {
    ...mapGetters([
      "get_profile",
      "get_live_backend_accounts",
      "get_demo_backend_accounts",
    ]),
    filteredLiveBackends() {
      return this.get_live_backend_accounts.filter(
        (account) => account.backend.type.toLowerCase() === "mt4"
      );
    },
    filteredDemoBackends() {
      return this.get_demo_backend_accounts.filter(
        (account) => account.backend.type.toLowerCase() === "mt4"
      );
    },
    
    getTermsLabel() {
        if (this.whitelabel === 'ICMMU') {
        return this.$t('provider-i-accept-the-copy-trading-provider-terms-and-conditions-mu');
        } else if (this.whitelabel === 'ICMVC') {
        return this.$t('provider-i-accept-the-copy-trading-provider-terms-and-conditions-vc');
        }
        return this.$t('provider-i-accept-the-copy-trading-provider-terms-and-conditions-trader');
    
    },
    getFollowerTermsLabel() {
        if (this.whitelabel === 'ICMMU') {
        return this.$t('follower-i-accept-the-copy-trading-terms-and-conditions-mu')
        }  else if (this.whitelabel === 'ICMVC') {
        return this.$t('follower-i-accept-the-copy-trading-terms-and-conditions-v');
        }
        return this.$t('follower-i-accept-the-copy-trading-terms-and-conditions-trader')
    }
    
  },
  mounted() {
    //console.log("User object:", this.get_profile);  // Check if user is defined
    //console.log("User ID:", this.get_profile?.id);  // Must be 21718
    this.prefillFormsFromProfile();
    const hash = this.$route.hash.replace("#", "");
    if (["provider", "follower"].includes(hash)) {
        this.activeTab = hash;
    } else {
        this.activeTab = "follower"; // Default tab
    };

    this.setTabFromHash(this.$route.hash);
       
  },
  watch: {
    activeTab(newVal) {
        if (this.$route.hash !== `#${newVal}`) {
        this.$router.replace({ hash: `#${newVal}` });
        }
    },
    // '$route.hash': function (newHash) {
    //     const tab = newHash.replace("#", "");
    //     if (["provider", "follower"].includes(tab)) {
    //     this.activeTab = tab;
    //     }
    // },
    '$route.hash'(newHash) {
        this.setTabFromHash(newHash);
    }
},
  methods: {
    ...mapActions(["copy_trading_follower", "copy_trading_provider"]),
    prefillFormsFromProfile() {
      const profile = this.get_profile;
      const fullName = `${profile.first_name || ""} ${profile.last_name || ""}`.trim();
      const email = profile.email || "";

      this.followerForm.name = fullName;
      this.followerForm.email = email;
      this.providerForm.name = fullName;
      this.providerForm.email = email;
    },
    handleFileUpload(event) {
        const file = event.target.files[0];
        if (!file) return;

        const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
        "image/jpeg",
        "image/png",
        ];

        const maxSizeMB = 5;

        if (!allowedTypes.includes(file.type)) {
        this.providerForm.tradingHistoryError = "Unsupported file type.";
        this.providerForm.tradingHistoryFile = null;
        
        return;
        }

        if (file.size > maxSizeMB * 1024 * 1024) {
        this.providerForm.tradingHistoryError = "File size exceeds 5 MB.";
        this.providerForm.tradingHistoryFile = null;
        
        return;
        }

        this.providerForm.tradingHistoryFile = file;
        this.providerForm.tradingHistoryError = "";
        
    },
    handleFileUpload1(event) {
        const file = event.target.files[0];
        if (!file) return;

        const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
        "image/jpeg",
        "image/png",
        ];

        const maxSizeMB = 5;

        if (!allowedTypes.includes(file.type)) {
        this.providerForm.logoError = "Unsupported file type.";
        this.providerForm.logo = null;
        return;
        }

        if (file.size > maxSizeMB * 1024 * 1024) {
        this.providerForm.logoError = "File size exceeds 5 MB.";
        this.providerForm.logo = null;
        return;
        }
        this.providerForm.logo = file;
        this.providerForm.logoError = "";
    },
    
    async submitFormFollower() {
        if (!this.followerForm.agree1 || !this.followerForm.agree2 || !this.followerForm.agree3) return;
        //this.isDisabled = true;
        const user = this.get_profile;
        this.followerForm.id = user.id;
        this.followerForm.username = user.username;

        // Clean empty/null values from form
        const cleanedData = Object.fromEntries(
        Object.entries(this.followerForm).filter(([_, v]) => v !== "" && v !== null)
        );

        const payload = cleanedData;
        //console.log("follower payload", payload)

        this.$store
        .dispatch("copy_trading_follower", payload)
        .then(() => {
            // Refresh user profile
            this.$store.dispatch("profile");

            // Redirect user based on suitability
            if (this.$store.getters.get_suitable?.result) {
            this.$router.replace("/");
            } else {
            this.$router.replace("/account-summary");
            }

            // Show success notification
            this.$notify({
            group: "foo",
            text: this.$t("registration-submitted-successfully"),
            type: "success",
            });
        })
        .catch((err) => {
            // Show warning notification
            this.$notify({
            group: "foo",
            text:
                err?.response?.data?.detail ||
            this.$t( "failed-to-submit-the-registration"),
            type: "warn",
            });
        })
        .finally(() => {
            this.isDisabled = false;
        });
    },
    // async submitFormProvider() {
    //     console.log("submitFormProvider triggered");
    //   if (!this.providerForm.agree1 || !this.providerForm.agree2 || !this.providerForm.agree3) return;
    //   //this.isDisabled = true;

    //   const user = this.get_profile;
    //   this.providerForm.id = user.id;
    //   this.providerForm.username = user.username;
      
    
    // // Clean empty/null values from form
    //     const cleanedData = Object.fromEntries(
    //     Object.entries(this.providerForm).filter(([_, v]) => v !== "" && v !== null)
    //     );

    //     const payload = cleanedData;
    //     console.log("provider payload", payload)

    //     this.$store
    //     .dispatch("copy_trading_provider", payload)
    //     .then(() => {
    //         // Refresh user profile
    //         this.$store.dispatch("profile");

    //         // Redirect user based on suitability
    //         if (this.$store.getters.get_suitable?.result) {
    //         this.$router.replace("/");
    //         } else {
    //         this.$router.replace("/account-summary");
    //         }

    //         // Show success notification
    //         this.$notify({
    //         group: "foo",
    //         text: this.$t("your-copy-trading-provider-registration-submitted-successfully"),
    //         type: "success",
    //         });
    //     })
    //     .catch((err) => {
    //         // Show warning notification
    //         this.$notify({
    //         group: "foo",
    //         text:
    //             err?.response?.data?.detail ||
    //         this.$t( "failed-to-submit-copy-trading-provider-registration"),
    //         type: "warn",
    //         });
    //     })
    //     .finally(() => {
    //         this.isDisabled = false;
    //     });
    // }, 
    async submitFormProvider() {
        //console.log("submitFormProvider triggered");

        if (!this.providerForm.agree1 || !this.providerForm.agree2 || !this.providerForm.agree3) return;

        const user = this.get_profile;
        this.providerForm.id = user.id;
        this.providerForm.username = user.username;

        // Loop through all fields and append to FormData
        const formData = new FormData();

        formData.append("id", this.providerForm.id);
        formData.append("name", this.providerForm.name);
        formData.append("email", this.providerForm.email);
        formData.append("account", this.providerForm.account);
        formData.append("strategy", this.providerForm.strategy);
        formData.append("trades", this.providerForm.trades);
        formData.append("risk", this.providerForm.risk);
        formData.append("winRate", this.providerForm.winRate);
        formData.append("drawdown", this.providerForm.drawdown);
        formData.append("monthlyReturn", this.providerForm.monthlyReturn);
        formData.append("totalReturn", this.providerForm.totalReturn);
        formData.append("bio", this.providerForm.bio);
        formData.append("brand", this.providerForm.brand);
        formData.append("agree1", this.providerForm.agree1);
        formData.append("agree2", this.providerForm.agree2);
        formData.append("agree3", this.providerForm.agree3);
        formData.append("id", this.providerForm.id);
        formData.append("username", this.providerForm.username);

        // Append file fields if present
        if (this.providerForm.logo) {
        formData.append("logo", this.providerForm.logo);
        }

        if (this.providerForm.tradingHistoryFile) {
        formData.append("tradingHistoryFile", this.providerForm.tradingHistoryFile);
        }

        // Append arrays individually (backend must support this format)
        this.providerForm.products_traded.forEach((item) => {
        formData.append("products_traded", item);
        });

        this.providerForm.holding_period.forEach((item) => {
        formData.append("holding_period", item);
        });

        try {
            await this.$store.dispatch("copy_trading_provider", formData);

            // Refresh user profile
            await this.$store.dispatch("profile");

            // Redirect user based on suitability
            if (this.$store.getters.get_suitable?.result) {
            this.$router.replace("/");
            } else {
            this.$router.replace("/account-summary");
            }

            // Show success notification
            this.$notify({
            group: "foo",
            text: this.$t("registration-submitted-successfully"),
            type: "success",
            });
        } catch (err) {
            this.$notify({
            group: "foo",
            text: err?.response?.data?.detail || this.$t("failed-to-submit-the-registration"),
            type: "warn",
            });
        } finally {
            this.isDisabled = false;
        }
    },

    setTabFromHash(hash) {
        if (hash === '#provider-registration-form') {
        this.activeTab = 'provider';
        } else if (hash === '#follower-registration-form') {
        this.activeTab = 'follower';
        } else {
        this.activeTab = 'follower'; 
        }
    },
    onTabChange(tab) {
        nextTick(() => {
        if (tab === "provider") {
            this.$router.push({ path: "/copy-trading", hash: "#provider-registration-form" }).catch(() => {});
        } else if (tab === "follower") {
            this.$router.push({ path: "/copy-trading", hash: "#follower-registration-form" }).catch(() => {});
        }
        });
    }
  }
};
</script>
  
  <style scoped>
  .input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    margin-top: 0.25rem;
    border-radius: 4px;
  }
  .checkbox {
    width: 1rem;
    height: 1rem;
  }
  .btn {
    background-color: #1e88e5;
    color: white;
    padding: 0.7rem 1.5rem;
    border: none;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
  }
  .btn:hover {
    background-color: #1565c0;
  }
  </style>
<style>
.tabs-component {
  margin-bottom: 1.5rem;
}

/* Container holding the tabs */
.tabs-component-tabs {
  display: flex;              /* make them horizontal */
  flex-direction: row;
  background: #f9f9f9;
  border-bottom: 2px solid #ddd;
  padding: 0;
  margin: 0;
}

/* Each tab */
.tabs-component-tab {
  list-style: none;
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  background: transparent;
  color: #333;
  font-weight: 500;
  transition: all 0.3s ease;
  border-radius: 6px 6px 0 0; /* rounded top corners */
  margin-right: 5px;
}

/* Hover effect */
.tabs-component-tab:hover {
  background: #eaeaea;
  color: #1e88e5;
}

/* Active tab */
.tabs-component-tab.is-active {
  background: #1e88e5; /* blue */
  color: #fff;
  border-bottom: none;
}


.tabs {
  font-family: Arial, sans-serif;
}

.tab-headers {
  display: flex; 
  gap: 10px;
  margin-bottom: 10px;
}

.tab-headers button {
  padding: 10px 20px;
  border: none;
  background-color: #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.tab-headers button.active {
  background-color: #007bff;
  color: white;
}

.tab-content {
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
}
input[type="file"]::-webkit-file-upload-button {
  background: #2563eb;
  color: white;
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

input[type="file"]::file-selector-button {
  background: #2563eb;
  color: white;
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.copy-trading {
  max-width: 1200px;
  margin: auto;
  padding: 2rem;
}
.tabs {
  font-family: Arial, sans-serif;
}

.tab-headers {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.tab-headers button {
  padding: 10px 20px;
  border: none;
  background-color: #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.tab-headers button.active {
  background-color: #007bff;
  color: white;
}

.tab-content {
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
}
</style>